// Uma única instância por aba: o BroadcastChannel não entrega a mensagem para quem a enviou,
// então a aba que trocou de conta não recebe o próprio aviso.
const channel = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel('brobot-session') : null

export function notifySessionChanged() {
  channel?.postMessage('changed')
}

export function onSessionChangedElsewhere() {
  if (!channel) return

  channel.onmessage = () => {
    localStorage.removeItem('userAuthenticated')

    if (document.hidden) {
      document.addEventListener('visibilitychange', () => location.reload(), { once: true })
    } else {
      location.reload()
    }
  }
}
